// extracted by mini-css-extract-plugin
export var caption = "style-module--caption--9c352";
export var centerImage = "style-module--centerImage--414a1";
export var wrapper = "style-module--wrapper--cb7c5";